import { useEffect, useRef } from 'react';

// useLifecycleEffect runs a callback on side-effect that takes in a boolean which represents
// whether the side-effect is triggered by componentDidMount or componentDidUpdate

export const useLifecycleEffect = (cb: (mount: boolean) => void, deps: any[]) => {
  const mount = useRef(true);

  useEffect(() => {
    // mount.current is true on the first side-effect when the component mount
    // and then false for the remaining side-effects which are triggered from an update
    const cleanup = cb(mount.current);
    mount.current = false;
    return cleanup;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
